export const trimSentence = (string) => {
    return string && string.split(' ').filter(word => word).join(' ');
}